import type { ReferralData } from '../interfaces'
import type { ReferralStore } from './interfaces'

export const actions = {
  setLoading (this: ReferralStore, payload: ReferralStore['loading']): void {
    this.loading = payload
  },
  setInviteProcessing (this: ReferralStore, payload: ReferralStore['inviteProcessing']): void {
    this.inviteProcessing = payload
  },
  setCreditsAnimation (this: ReferralStore, payload: ReferralStore['creditsAnimation']): void {
    this.creditsAnimation = payload
  },
  setBalanceAnimation (this: ReferralStore, payload: ReferralStore['balanceAnimation']): void {
    this.balanceAnimation = payload
  },
  setReferralData (this: ReferralStore, payload: ReferralData): void {
    this.balance = payload.balance
    this.previousBalance = payload.previous_balance
    this.referralLink = payload.link
    this.savings = payload.savings
    this.referrals = payload.referrals
    this.loaded = true
  },
}
